import React from 'react';

import './FloorPlansPageSkeleton.scss';

const FloorPlansPageSkeletonItem = () => (
  <div className="gridItem skeleton-item">
    <div className="skeleton-trigger">
      <div className="imgContainer">
        <div className="skeleton-image" />
      </div>
    </div>
    <div className="floorplanInfo">
      <div className="skeleton-title" />
      <div className="skeleton-subtitle" />
    </div>
  </div>
);

const FloorPlansPageSkeleton = () => (
  <div className="gridContainer">
    {[...Array( 6 )].map( ( _, index ) => (
      <FloorPlansPageSkeletonItem key={`skeleton-${index}`} />
    ) )}
  </div>
);

export default FloorPlansPageSkeleton;
